import React from 'react';
import { Text } from '@carnica/ui-kit';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { enhancedConnect } from "../../utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _InstructionStep = function _InstructionStep(_ref) {
  var circleNumber = _ref.circleNumber,
    icon = _ref.icon,
    description = _ref.description,
    _ref$titleLarge = _ref.titleLarge,
    titleLarge = _ref$titleLarge === void 0 ? false : _ref$titleLarge,
    title = _ref.title,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'secondary' : _ref$theme;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('step-wrapper', theme),
    "data-t-id": "components-InstructionSteps"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('step-container')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('step-circle')
  }, icon ? /*#__PURE__*/React.createElement("img", {
    alt: title,
    height: "24",
    src: icon,
    width: "24"
  }) : /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    variant: "body-accent-small"
  }, circleNumber)), /*#__PURE__*/React.createElement("div", {
    className: cx('texts-container')
  }, /*#__PURE__*/React.createElement(Text, {
    variant: titleLarge ? 'body-medium' : 'body-small'
  }, title), description && /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    variant: "body-small"
  }, description))));
};
export var InstructionStep = enhancedConnect({
  circleNumber: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  titleLarge: PropTypes.bool,
  description: PropTypes.string,
  theme: PropTypes.oneOf(['primary', 'secondary'])
})(_InstructionStep);